import {AssignmentOutlined} from "@mui/icons-material";
import {Box, Card, CardContent, CardHeader, Link} from "@mui/material";
import {CurrencyFormat, defined} from "@variocube/app-ui";
import React from "react";
import {Invoice} from "../../../api";
import {Typography} from "../../../component/typography";
import {useLocalization} from "../../../i18n";
import {notNull} from "../../../util";

export function InvoiceSummaryCard({invoice}: { invoice: Invoice }) {
	const {t, e} = useLocalization();

	const total = defined(invoice.gross) ? invoice.gross + (invoice.tip ?? 0) : undefined;

	return (
		<Card>
			<CardHeader
				title={<Typography startAdornment={<AssignmentOutlined />}>{t("invoices.details.summary")}</Typography>}
			/>
			<CardContent>
				<Typography justifyContent="center" gutterBottom>
					{e("invoices.invoiceStates", invoice.invoiceState)}
				</Typography>

				{!notNull(invoice.audited) && (invoice.auditors ?? []).length > 0 && (
					<>
						<Typography color="textSecondary" textAlign="center" gutterBottom>
							{t("invoices.details.auditHint")}
						</Typography>
						{invoice.auditorUsers?.map(a => (
							<Typography key={a.email} color="textSecondary" justifyContent="center" gutterBottom>
								{a.firstname} {a.lastname}
								<br />
								<Link href={`mailto:${a.email}`}>{a.email}</Link>
							</Typography>
						))}
					</>
				)}

				{invoice.invoiceType == "ExpensesInvoice" && total && (
					<Box my={2}>
						<Typography variant="h3" textAlign="center" gutterBottom justifyContent="center">
							<CurrencyFormat value={total} currency={invoice.currency ?? "EUR"} />
						</Typography>
						<Typography color="textSecondary" textAlign="center">
							{t("invoices.details.amountTransferText")}
						</Typography>
					</Box>
				)}

				<Typography color="textSecondary" textAlign="center" gutterBottom>
					<strong>
						{t("common.hint")}:
						<br />
						{t("invoices.details.keepOriginHint")}
					</strong>
				</Typography>
			</CardContent>
		</Card>
	);
}
